var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { clientLogging } from '@bfa/nextjs-common/services';
import { useState } from 'react';
import useAddOneOffItem from '../../../../../../../hooks/useAddOneOffItem';
import useBusinessConfiguration from '../../../../../../../hooks/useBusinessConfiguration';
import useSubscriptionAddItem from '../../../../../../../hooks/useSubscriptionAddItem';
import { NBProductSubscriptionType } from '../../../../../../../types/enums';
import { SUBSCRIBED_LANDING_PAGE_EVENTS as LANDING_EVENTS, SUBSCRIBED_LANDING_UPSELL_SECTION_EVENTS as UPSELL_EVENTS, } from '../../../../../../../utils/analytics/events';
import { formatPriceAsWholeNumber, getDefaultRelatedProductToSubscribe, getDeliveryMonthForOneOffItem, getDeliveryMonthForSubscriptionItem, getProductSellingOptions, } from '../../../../../../../utils/subscription';
import { useUpsellContext } from '../../Context';
var useCategoryProduct = function (product) {
    var _a = useUpsellContext(), onAddItemSuccess = _a.onAddItemSuccess, onAddItemError = _a.onAddItemError, subscription = _a.subscription;
    var _b = __read(useAddOneOffItem(subscription), 1), addOneOffItem = _b[0];
    var trackEvent = useBusinessConfiguration().trackEvent;
    var _c = __read(useState(false), 2), adding = _c[0], setAdding = _c[1];
    var _d = __read(useState(false), 2), showModal = _d[0], setShowModal = _d[1];
    var _e = getProductSellingOptions(product), isOnlyOneOff = _e.isOnlyOneOff, isOnlySubscribe = _e.isOnlySubscribe, moreThanOneSellingOption = _e.moreThanOneSellingOption;
    var _f = __read(useSubscriptionAddItem(subscription), 1), addSubscribeItem = _f[0];
    var isKit = (product === null || product === void 0 ? void 0 : product.subscriptionType) === NBProductSubscriptionType.KIT;
    var relatedProduct = getDefaultRelatedProductToSubscribe(subscription.subscriptionItems, product.refillProducts, product.relatedProducts[0]);
    /**
     * Handles click for Landing Page > Upsell Module > Product CTA when subscribe only.
     * TODO: this should be centralize in one place REF-591.
     */
    var clickOnSubscribeCTA = function () { return __awaiter(void 0, void 0, void 0, function () {
        var result, data, errors, deliveryMonth;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setAdding(true);
                    if (!isKit) return [3 /*break*/, 2];
                    return [4 /*yield*/, addOneOffItem(product.id)];
                case 1:
                    result = _a.sent();
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, addSubscribeItem({
                        productId: product.id,
                        monthsOffset: 1,
                        cadence: 1,
                    })];
                case 3:
                    result = _a.sent();
                    _a.label = 4;
                case 4:
                    data = result.data, errors = result.errors;
                    if (!errors) return [3 /*break*/, 5];
                    clientLogging.logError(errors[0]);
                    onAddItemError(product);
                    return [3 /*break*/, 7];
                case 5:
                    deliveryMonth = getDeliveryMonthForSubscriptionItem(data, product.id);
                    onAddItemSuccess(product, deliveryMonth);
                    trackEvent(__assign(__assign({}, UPSELL_EVENTS.CLICK_ON_SUBSCRIBE_PRODUCT), { properties: {
                            productId: product.id,
                        } }));
                    if (!(isKit && relatedProduct)) return [3 /*break*/, 7];
                    return [4 /*yield*/, addSubscribeItem({
                            productId: relatedProduct.id,
                            monthsOffset: 2,
                            cadence: 1,
                        })];
                case 6:
                    _a.sent();
                    _a.label = 7;
                case 7:
                    setAdding(false);
                    return [2 /*return*/];
            }
        });
    }); };
    /**
     * Handles click for Landing Page > Upsell Module > Product CTA when one off only.
     */
    var clickOnAddAsOneOffCTA = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, data, errors, deliveryMonth;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setAdding(true);
                    return [4 /*yield*/, addOneOffItem(product.id)];
                case 1:
                    _a = _b.sent(), data = _a.data, errors = _a.errors;
                    if (errors) {
                        clientLogging.logError(errors[0]);
                        onAddItemError(product);
                    }
                    else {
                        deliveryMonth = getDeliveryMonthForOneOffItem(data, product.id);
                        onAddItemSuccess(product, deliveryMonth);
                        trackEvent(__assign(__assign({}, UPSELL_EVENTS.CLICK_ON_BUY_ONE_OFF_PRODUCT), { properties: {
                                productId: product.id,
                            } }));
                    }
                    setAdding(false);
                    return [2 /*return*/];
            }
        });
    }); };
    /**
     * Handles click for Landing Page > Upsell Module > Product CTA.
     *
     * @param event - Mouse event.
     */
    var onProductCTAClick = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            event === null || event === void 0 ? void 0 : event.preventDefault();
            if (moreThanOneSellingOption) {
                setShowModal(true);
                trackEvent(__assign(__assign({}, LANDING_EVENTS.CLICK_ON_OPEN_ADD_PRODUCT_POPUP), { properties: {
                        productId: product.id,
                    } }));
            }
            else if (isOnlySubscribe) {
                clickOnSubscribeCTA();
            }
            else if (isOnlyOneOff) {
                clickOnAddAsOneOffCTA();
            }
            return [2 /*return*/];
        });
    }); };
    return {
        adding: adding,
        isOnlyOneOff: isOnlyOneOff,
        isOnlySubscribe: isOnlySubscribe,
        onProductCTAClick: onProductCTAClick,
        showModal: showModal,
        hideModal: function () { return setShowModal(false); },
        formattedPrice: formatPriceAsWholeNumber(product.price),
        formattedOneOffPrice: formatPriceAsWholeNumber(product.oneOffPrice),
        formattedRegularPrice: formatPriceAsWholeNumber(product.regularPrice),
    };
};
export default useCategoryProduct;
